export const apiProxyUrl =
  process.env.REACT_APP_HTTP_BASE_URL || "http://localhost:8000/api/";
